export const UNICODE = {
  middleDot: '\u00B7',
  nbsp: '\u00A0',
  superscriptTwo: '\u00B2',
}
